import React from 'react';
import Breadcrumb from './Breadcrumb.jsx';
import EditorControls from './EditorControls.jsx';
import Button from 'aldoo-ra/Button';
import { Icons } from '../../components/Icon.jsx';

const TopToolbar = ({ controller }) => {
  const {
    breadcrumbs,
    selectedCount,
    isLiveMode,
    isSaving,
    onNavigate,
    onSave,
    onToggleLiveMode,
    onShowSettings,
    viewportWidth,
    setViewportWidth,
    activeBreakpoint,
    setActiveBreakpoint,
    onClose
  } = controller;
  return (
    <div className="h-10 bg-admin_paper border-b border-admin_bordered flex items-center px-4 justify-between relative z-20 shadow-sm">
      <div className="flex items-center gap-2">
        <Button variant="admin_secondary" onClick={onClose} className="p-1 min-h-0 h-8">
          <Icons.Close className="w-4 h-4" />
        </Button>
        <Breadcrumb crumbs={breadcrumbs} onNavigate={onNavigate} />
      </div>
      <EditorControls
        selectedCount={selectedCount}
        isLiveMode={isLiveMode}
        isSaving={isSaving}
        onSave={onSave}
        onToggleLiveMode={onToggleLiveMode}
        onShowSettings={onShowSettings}
        viewportWidth={viewportWidth}
        setViewportWidth={setViewportWidth}
        activeBreakpoint={activeBreakpoint}
        setActiveBreakpoint={setActiveBreakpoint}
      />
    </div>
  );
};

export default TopToolbar;
